const words = ["Sehen", "Hören", "Mitsingen", "Mitmachen", "Entdecken"];

export const Marquee = () => {
  const row = [...words, ...words, ...words];
  return (
    <div className="marquee py-5" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <span key={half} className="inline-flex items-baseline">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="inline-flex items-baseline">
                <span className="font-display italic text-3xl sm:text-4xl px-6 text-[color:var(--ink)] opacity-80">
                  {w}
                </span>
                <span className="text-xl" style={{ color: ["#D95338", "#3A7BD5", "#E5A93C", "#4A8B5D"][i % 4] }}>
                  ●
                </span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
};
